import { render } from "./AudienceTags.vue?vue&type=template&id=06f522da"
import script from "./AudienceTags.vue?vue&type=script&lang=js"
export * from "./AudienceTags.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__